var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wallet case-history" }, [
    _c("div", { staticClass: "fairness-verification-box" }, [
      _c("div", { staticClass: "title" }, [_vm._v("公平性验证")]),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          " 我们的开箱系统采用公平可验证的随机数生成算法。服务器种子哈希 (Server Seed Hash) 是在开箱前公开的加密字符串，代表了服务器预设的随机数种子。客户端种子 (Client Seed) 是由您掌控的随机因素。通过两者的结合，您可以验证每一次开箱的结果完全随机且未被篡改。 "
        ),
      ]),
      _c("div", { staticClass: "input-group" }, [
        _c(
          "div",
          { staticClass: "input-item" },
          [
            _c("label", [_vm._v("服务器种子Hash (Server Seed Hash)")]),
            _c("Input", {
              staticClass: "cs-custom-input",
              attrs: { readonly: "", placeholder: "加载中..." },
              model: {
                value: _vm.serverSeedHash,
                callback: function ($$v) {
                  _vm.serverSeedHash = $$v
                },
                expression: "serverSeedHash",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "input-item" }, [
          _c("label", [_vm._v("客户端种子 (Client Seed)")]),
          _c(
            "div",
            { staticClass: "client-seed-wrapper" },
            [
              _c("Input", {
                staticClass: "cs-custom-input",
                attrs: { placeholder: "请输入客户端种子" },
                model: {
                  value: _vm.clientSeed,
                  callback: function ($$v) {
                    _vm.clientSeed = $$v
                  },
                  expression: "clientSeed",
                },
              }),
              _c(
                "Button",
                {
                  staticClass: "cs-btn cs-btn--gold",
                  attrs: { loading: _vm.savingSeed },
                  on: { click: _vm.saveClientSeed },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "input-item",
            staticStyle: { width: "100%", "min-width": "100%" },
          },
          [
            _c("label", [_vm._v("服务器种子 (Server Seed)")]),
            _c(
              "div",
              { staticClass: "client-seed-wrapper" },
              [
                _c("Input", {
                  staticClass: "cs-custom-input",
                  attrs: { readonly: "", placeholder: "点击右侧按钮获取" },
                  model: {
                    value: _vm.serverSeed,
                    callback: function ($$v) {
                      _vm.serverSeed = $$v
                    },
                    expression: "serverSeed",
                  },
                }),
                _c(
                  "Button",
                  {
                    staticClass: "cs-btn cs-btn--darkgold",
                    attrs: { loading: _vm.regeneratingSeed },
                    on: { click: _vm.regenerateServerSeed },
                  },
                  [_vm._v("获取当前服务器种子并重新生成")]
                ),
                _c(
                  "Button",
                  {
                    staticClass: "cs-btn cs-btn--outline",
                    on: { click: _vm.openThirdPartyVerify },
                  },
                  [_vm._v("跳转第三方网站验证")]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
    _c("div", { staticClass: "wallet_detail_box" }, [
      _c("table", { staticClass: "list" }, [
        _vm._m(0),
        _c(
          "tbody",
          _vm._l(_vm.historyData.data.list, function (item, index) {
            return _c("tr", { key: index }, [
              _c("td", [
                _c("span", { staticClass: "box-name-tag" }, [
                  _vm._v(_vm._s(item.casename || "未知箱子")),
                ]),
              ]),
              _c("td", [
                _c("div", { staticClass: "award-cell" }, [
                  _c(
                    "div",
                    {
                      staticClass: "img-wrapper",
                      class: "rarity-" + (item.rarity || "default"),
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm._f("imgfilter")(item.itempic),
                          alt: "",
                        },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "award-info" }, [
                    _c(
                      "span",
                      { staticClass: "name", attrs: { title: item.itemname } },
                      [_vm._v(_vm._s(_vm.getAwardName(item.itemname)))]
                    ),
                    _c("span", { staticClass: "sub-name" }, [
                      _vm._v(_vm._s(_vm.getAwardSubName(item.itemname))),
                    ]),
                  ]),
                ]),
              ]),
              _c("td", [
                _c("span", { staticClass: "time-text" }, [
                  _vm._v(_vm._s(item.time)),
                ]),
              ]),
              _c("td", [
                _c(
                  "span",
                  {
                    staticClass: "hash-text",
                    attrs: { title: item.serverHash },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          item.serverHash
                            ? item.serverHash.substring(0, 10) + "..."
                            : "-"
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("td", [
                _c(
                  "span",
                  {
                    staticClass: "seed-text",
                    attrs: { title: item.clientHashSeed },
                  },
                  [_vm._v(_vm._s(item.clientHashSeed || "-"))]
                ),
              ]),
              _c("td", [
                _c("span", { staticClass: "num-text" }, [
                  _vm._v(_vm._s(item.timestamp)),
                ]),
              ]),
              _c("td", [
                _c("span", { staticClass: "num-text text-muted" }, [
                  _vm._v(_vm._s(item.caseMaxRoll)),
                ]),
              ]),
              _c("td", [
                _c("span", { staticClass: "roll-value-highlight" }, [
                  _vm._v(_vm._s(item.rate)),
                ]),
              ]),
            ])
          }),
          0
        ),
      ]),
      _vm.historyData.data.list.length === 0
        ? _c("div", { staticClass: "none-item" }, [
            _c("img", {
              attrs: { src: require("@/assets/images/none-item.svg"), alt: "" },
            }),
            _c("div", [_vm._v("暂无开箱记录")]),
          ])
        : _vm._e(),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.historyData.data.total > _vm.historyData.size,
            expression: "historyData.data.total > historyData.size",
          },
        ],
        staticClass: "pagination-container",
      },
      [
        _c("Page", {
          attrs: {
            current: _vm.historyData.current,
            total: _vm.historyData.data.total,
            "page-size": _vm.historyData.size,
            "class-name": "page",
          },
          on: {
            "update:current": function ($event) {
              return _vm.$set(_vm.historyData, "current", $event)
            },
            "on-change": _vm.pageF,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("箱子")]),
        _c("th", [_vm._v("奖品")]),
        _c("th", [_vm._v("开箱时间")]),
        _c("th", [_vm._v("服务器Hash")]),
        _c("th", [_vm._v("客户端种子")]),
        _c("th", [_vm._v("Timestamp")]),
        _c("th", [_vm._v("最大Roll值")]),
        _c("th", [_vm._v("Roll值")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }